import React, { Component } from 'react';
import { connect } from "react-redux";
import './Main.css';
import { Table, Container, Card } from 'react-bootstrap';


export default class Settings extends Component {

  render() {

    if(!this.props.target)
      return ""

		// キーと値を1次元に展開
		const settings = this.props.target?.setting || [];
    const flattenedSettings = settings.flatMap(obj =>
      Object.entries(obj).map(([key, value]) => ({ key, value }))
    );

    return (
      settings.length > 0 && (
      <Container className="my-4">
        <Card>
          <Card.Header as="h5">設定一覧</Card.Header>
          <Card.Body>
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th>項目名</th>
                  <th>値</th>
                </tr>
              </thead>
              <tbody>
                {flattenedSettings.map((item, index) => (
                  <tr key={index}>
                    <td>{item.key}</td>
                    <td>{item.value}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Container>
      )
    );
  };
}
